import RowOptionsMenu, { type RowOptionItem } from '../../../../shared/components/RowOptionsMenu';
import type { Contact } from '../../../../types/InfrastructureManagerTypes';
import { ContactAction } from '../../../../enums/contactActions';
import styles from './ContactGrid.module.scss';

interface Props {
  contact: Contact;
  groupId: number;
  options: RowOptionItem[];
  onEdit: (contact: Contact) => void;
  onMove: (contact: Contact, fromGroupId: number, toGroupId: number) => void;
  onDuplicate: (contact: Contact, targetGroupIds: number[]) => void;
  onDelete: (contact: Contact, groupId: number, anchor: HTMLElement | null) => void;
}

export const ContactActionsCell = ({ contact, groupId, options, onEdit, onMove, onDuplicate, onDelete }: Props) => {
  const handleSelect = (action: string, anchor: HTMLElement | null, parentAction?: string) => {
    const selectedAction = parentAction ?? action;
    if (selectedAction === ContactAction.EDIT) onEdit(contact);
    // Inside the move panel, `action` is the chosen target group id.
    if (selectedAction === ContactAction.MOVE) onMove(contact, groupId, Number(action));
    if (selectedAction === ContactAction.DELETE) onDelete(contact, groupId, anchor);
  };

  const handleMultiSelect = (targetGroupIds: string[]) => onDuplicate(contact, targetGroupIds.map(Number));

  return (
    <span className={styles.actionCell}>
      <RowOptionsMenu options={options} header="CONTACT OPTIONS" onSelect={handleSelect} onMultiSelect={handleMultiSelect} />
    </span>
  );
};
